"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleSchema = exports.LocaleCodeTypeSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const localeCodeType = [...data_1.localeCode];
exports.LocaleCodeTypeSchema = yup_lib_1.default.string().oneOf(data_1.localeCode).required();
const localeLanguageType = [...data_1.localeLanguage];
exports.LocaleSchema = yup_lib_1.default.object().shape({
    code: exports.LocaleCodeTypeSchema,
    language: yup_lib_1.default.string().oneOf(data_1.localeLanguage).required()
});
